/* @sravni/react-header version 0.2.43 */
/** Delay the appearance of the menu in milliseconds, helps not to quickly switch to another menu
 * item when the cursor moves diagonally to it subitem (only for DesktopHeader)
 */
var MENU_DELAY = 250;

export { MENU_DELAY };
//# sourceMappingURL=settings.js.map
